export default {
  POPOVER_LABEL: 'popover-label',
  POPOVER_LABEL_TEXT: 'popover-label-text',
  ASSIGNED_LABEL: 'assigned-label',
  ASSIGNED_SECTIONS: 'assigned-sections',
  UNASSIGNED_LABEL: 'unassigned-label',
  SECTION_ROW: 'section-row',
  SECTION_NAME: 'section-name',
  ASSIGNED_ICON: 'assigned-icon',
  UNWATCHED_COLUMN: 'unwatched-column',
  WATCHED_COLUMN: 'watched-column',
  TOGGLE_STUDENTS_CONTAINER: 'toggle-students-container',
  UNWATCHED_COLUMN_TEXT: 'unwatched-text',
  WATCHED_COLUMN_TEXT: 'watched-text',
  STUDENTS_CONTAINER: 'students-container',
  WATCHED_STUDENT: 'watched-student',
  UNWATCHED_STUDENT: 'unwatched-student',
  WATCHED_POPOVER_CONTAINER: 'watched-popover-container',
  STATIC_DATA: 'static-data',
  NO_STUDENT_TEXT: 'no-students-text',
};
